// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__8Rwe4","name":"ConsentHeader_name__2TB_K","birthday":"ConsentHeader_birthday__2qO6R","skeleton":"ConsentHeader_skeleton__2V3eE"};